import {Language} from '../umpire-language-service';

export interface UmpireImage {
  id: string;

  author: string | null;

  description: string | null;
  meta: UmpireImageMeta;

  variants: UmpireImageVariants;

  type: 'image';

  path: string;

  url: string;

  transforms: UmpireImageTransforms;

  locale: Language;

  availabe_translations: Language[];
}

export interface UmpireImageTransforms {
  [key: string]: {
    crop: UmpireImageCropParams;
    resize?: UmpireImageResizeParams;
  };
}

export enum UmpireImageCropType {
  full = 'full',
  thumb = 'thumb',
  mobileHero = 'mobileHero',
  desktopHero = 'desktopHero',
}

export interface UmpireImageCropVariantParams {
  ratio: number;
  ratioLabel: string;
  minWidth: number;
  minHeight: number;
}

export interface UmpireImageCropParams {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface UmpireImageResizeParams {
  width: number;
  height: number;
}

export interface UmpireImageVariants {
  [key: string]: UmpireImageVariant;
}

export interface UmpireImageVariant {
  url: string;

  meta: UmpireImageMeta;
}

export interface UmpireImageMeta {
  height: number;

  width: number;

  file_type: UmpireImageFileType;

  size?: number;
}

export type UmpireImageFileType = 'jpg' | 'png' | 'svg' | 'jpeg';
